import axios from "axios";
import {importRevenue} from '../_constants/api.constant'
import {getSelfToken} from '../../_helpers/auth/secureToken'
export async function ListOfImportedRevenue(paramsObj){
    const response=await axios.get(
        importRevenue.LIST,
        {
            params:paramsObj,
            headers:{
                Authorization: 'Token '+getSelfToken(),
            },
        }
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        // handle error
     

        console.log(error);
        console.log(error.response);
        return error.response;
        });
    return response;
}